import React, { Component } from "react";
import TextInput from "../../../textInput";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import ModalConstructorCode from "../../../../pages/viewUnitPage/modal-constructor-code";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const buildRowCode = (codeModels) =>
  codeModels.map((x) => x.Code + (x.DotAfter === "1" ? "." : "")).join("");

class CreateLessonCompetencyStandardsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CompetencyStandards: [],
      currentEditingId: 0,
      currentItemCode: null,
      showModal: false,
    };

    this.addCodeField = this.addCodeField.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  componentWillReceiveProps = (nextProps) => {
    if (!this.state.showModal && this.props.codes !== nextProps.codes) {
      const competencyStandardsNew = (nextProps.codes || []).map((item) => {
        return {
          ...item,
          rowCode: buildRowCode(item.ConstructedCodeCodeModels || []),
        };
      });
      this.setState({
        CompetencyStandards: competencyStandardsNew,
      });
    }
  };

  addCodeField = () => {
    const rowCompetencyStandards = [...this.state.CompetencyStandards];
    const lastElement =
      rowCompetencyStandards[rowCompetencyStandards.length - 1];
    if (!lastElement || lastElement.rowCode) {
      rowCompetencyStandards.push({
        Id: 0,
        MainCode: "0",
        rowCode: "",
        ConstructedCodeCodeModels: [],
      });
    }
    this.setState({ CompetencyStandards: rowCompetencyStandards });
  };

  handleShow = (i) => {
    const currentItemCode = this.state.CompetencyStandards[i];
    this.setState({
      showModal: true,
      currentEditingId: i,
      currentItemCode,
    });
  };

  handleClose() {
    this.setState({ showModal: false });
  }

  updateCodes = (competencyStandards) => {
    this.setState({
      CompetencyStandards: competencyStandards,
    });
    this.props.onDataChange(competencyStandards);
  };

  handleUpdateCode = (vectorCode) => {
    const i = this.state.currentEditingId;
    const competencyStandards = [...this.state.CompetencyStandards];
    competencyStandards[i].ConstructedCodeCodeModels = [...vectorCode];
    competencyStandards[i].rowCode = buildRowCode(vectorCode);
    this.updateCodes(competencyStandards);
  };

  removeItem = (index) => {
    const competencyStandards = [...this.state.CompetencyStandards];
    competencyStandards.splice(index, 1);
    this.updateCodes(competencyStandards);
  };

  render() {
    return (
      <div className="mb-4">
        <div className="d-flex align-items-center mt-4">
          <b>
            <FormattedMessage id="cl-basic-competency-standards" />
          </b>
          <Button className="ml-3" onClick={this.addCodeField}>
            + <FormattedMessage id="cl-add-standard" />
          </Button>
        </div>

        <hr />
        {this.state.CompetencyStandards.map((item, i) => (
          <div key={i}>
            <Row className="space-radioButton Region-AddCode">
              <Col className="Region-AddCode--desc">
                <TextInput
                  labelID={"cl-basic-competency-standards"}
                  textName="lessonCompetencyStandardCode"
                  readOnly={true}
                  content={item.rowCode}
                  onChange={() => {}}
                />
              </Col>
              <hr />
              <Col xs={8} md={4}>
                <Button onClick={() => this.handleShow(i)}>
                  <FormattedMessage id="cl-btn-build-standard" />
                </Button>
                <Button
                  className="btn-trash"
                  onClick={() => this.removeItem(i)}
                  variant="light"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </Col>
            </Row>
          </div>
        ))}
        {this.state.showModal && (
          <Modal show={this.state.showModal} onHide={this.handleClose}>
            <Modal.Header closeButton className="w-auto"></Modal.Header>
            <ModalConstructorCode
              handleUpdateCode={this.handleUpdateCode}
              currentItemCode={this.state.currentItemCode}
              handleClose={this.handleClose}
              showInputCode={true}
            />
          </Modal>
        )}
      </div>
    );
  }
}

export default CreateLessonCompetencyStandardsSection;
